import { TextField } from "@material-ui/core";
import React, { useCallback, useMemo, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { dateTimeReportFormatter } from "../../fomatters/DateFormatter";
import InputSelect from "../InputSelect";
import InputSelectGame from "../InputSelectGame";
import Report from "../Report";

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() + 1);

const startDateValue = new Date().toISOString().split("T")[0];
const endDateValue = currentDate.toISOString().split("T")[0];

const getLineChanged = (item) => {
  if (item?.play === 0 || item?.play === 1) {
    return "Side";
  } else if (item?.play === 2 || item?.play === 3) {
    return "Total";
  } else if (item?.play === 4 || item?.play === 5) {
    return "$-Line";
  }
};

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function LineHistoryByAgent() {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);

  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback((event) => {
    setStartDate(event.target.value);

    const endDateChanged = new Date(event.target.value);
    endDateChanged.setDate(endDateChanged.getDate() + 1);
    setEndDate(endDateChanged.toISOString().split("T")[0]);
  }, []);

  const [agent, setAgent] = useState("");
  const onAgentChanged = useCallback((a) => setAgent(a), []);
  const { values: agents } = useDataFormatterHook({
    addEmpty: true,
    value: "agent",
    text: "agent",
    path: `/Agent/Agent_GetList2Result?idUser=${userInfo.userId}`,
  });

  const [idGame, setIdGame] = useState(0);
  const onGameChanged = useCallback((g) => setIdGame(g), []);

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="Game Date"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Agent"
          name="name"
          data={agents}
          placeholder="DataFormatter"
          setSelectValue={onAgentChanged}
          startValue={""}
        />
        <InputSelectGame
          startDate={startDate}
          endDate={endDate}
          setSelectValue={onGameChanged}
        />
      </div>
      <Report
        title="Line History By Agent Report"
        getUrl={() => "/Reports/Report_Line_HistoryByAgent_2"}
        getProcess={(data) =>
          data
            .filter((item) => item.placedDate)
            .map((item) => ({
              ...item,
              lineChanged: getLineChanged(item),
            }))
        }
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          Agent: agent,
          IdGame: idGame,
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="placedDate"
          dataFormat={dateTimeReportFormatter}
        >
          Placed Date
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="changeValue">
          Change Value
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="lineChanged">
          Line Changed
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="teamName">
          Team Name
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="loginName">
          User
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="phoneLine">
          Phone Line
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default LineHistoryByAgent;
